//For more information: https://github.com/angular/flex-layout/wiki/Breakpoints
import { BREAKPOINT } from '@angular/flex-layout';
import { MEDIA_BREAKPOINTS } from './media.config';

const CUSTOM_BREAKPOINTS = [
  {
    alias: 'xs',
    mediaQuery: MEDIA_BREAKPOINTS.XS,
    overlapping: false,
    priority: 1001, // Needed if overriding the default breakpoint
  },
  {
    alias: 'sm',
    mediaQuery: MEDIA_BREAKPOINTS.SM,
    overlapping: false,
    priority: 1001,
  },
  {
    alias: 'md',
    mediaQuery: MEDIA_BREAKPOINTS.MD,
    overlapping: false,
    priority: 1001,
  },
  {
    alias: 'lg',
    mediaQuery: MEDIA_BREAKPOINTS.LG,
    overlapping: false,
    priority: 1001,
  },
  {
    alias: 'xl',
    mediaQuery: MEDIA_BREAKPOINTS.XL,
    overlapping: false,
    priority: 1001,
  },
];

export const CustomBreakPointsProvider = {
  provide: BREAKPOINT,
  useValue: CUSTOM_BREAKPOINTS,
  multi: true,
};
